<template>
    <div :key="key">
        <b-input
            ref="description"
            v-model="form.description"
            size="sm"
            :class="reactiveClass"
            @change="savePoint"
        />
    </div>
</template>

<script>
import TableFormHandler from '../../../../../common/mixins/TableFormHandler'

export default {
    name: 'DescriptionForm',

    mixins: [TableFormHandler],

    props: {
        point: {},
    },

    created() {
        this.align = 'left'
    },

    methods: {
        async savePoint() {
            try {
                await axios.put(
                    `/pendingPoints/${this.point.id}/description`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.description = this.point.description
        },

        setInitialKey() {
            this.key = `description${this.point.id}`
        },

        unFocus() {
            this.$refs.description.blur()
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
